import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
// import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.page.html',
  styleUrls: ['./setting.page.scss'],
})
export class SettingPage implements OnInit {

  tokenData:any;
  constructor(private storage: Storage, private router: Router) {
    this.tokenData =false;

   }

  ngOnInit() {
  }

ionViewWillEnter(){
  this.storage.get('tokenData').then((val) => {
    if(val){
    this.tokenData =true;
    console.log('tokenData', val);
  }
}); 

}

  logout(){
    this.storage.remove('tokenData');
    this.router.navigate(['/login'])
  }

  signin(){
    this.router.navigate(['/login'])
  }


  privacypolicy(){
   
  }

  terms(){
  
  }

  
  about(){
    this.router.navigate(['/about-us'])
  }

  support(){
    this.router.navigate(['/support'])
  }


}
